import React from "react";

const CustomerIcon = (props: any) => {
  return (
    <div>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1039_10475)">
          <path
            opacity="0.8"
            d="M11.9334 11.5333C13.7334 11.5333 15.1334 10.0667 15.1334 8.26668C15.1334 6.46668 13.6667 5.06668 11.8667 5.06668C10.0667 5.06668 8.66675 6.53335 8.66675 8.26668C8.66675 10.0667 10.1334 11.5333 11.9334 11.5333ZM11.8667 6.40001C11.9334 6.40001 11.9334 6.40001 11.8667 6.40001C12.9334 6.40001 13.8001 7.26668 13.8001 8.33335C13.8001 9.40001 12.9334 10.2 11.8667 10.2C10.8001 10.2 10.0001 9.33335 10.0001 8.33335C10.0001 7.26668 10.8667 6.40001 11.8667 6.40001Z"
            fill={props?.color ?? "black"}
          />
          <path
            opacity="0.8"
            d="M21.8 11.1333C20.5333 9.99999 18.8667 9.39999 17.1333 9.46666H16.6C16.4667 9.99999 16.2667 10.4667 16 10.8667C16.4 10.8 16.7333 10.8 17.1333 10.8C18.4 10.7333 19.6667 11.1333 20.6667 11.8667V16.6667H22V11.3333L21.8 11.1333Z"
            fill={props?.color ?? "black"}
          />
          <path
            opacity="0.8"
            d="M15.6001 5.2C15.9334 4.4 16.8667 4 17.7334 4.33334C18.5334 4.66667 18.9334 5.6 18.6001 6.46667C18.3334 7.06667 17.7334 7.46667 17.1334 7.46667C17.0001 7.46667 16.8001 7.46667 16.6667 7.4C16.7334 7.73334 16.7334 8.06667 16.7334 8.33333V8.73334C16.8667 8.73334 17.0001 8.8 17.1334 8.8C18.8001 8.8 20.1334 7.46667 20.1334 5.86667C20.1334 4.2 18.8001 2.86667 17.2001 2.86667C16.1334 2.86667 15.2001 3.4 14.6667 4.33334C15.0001 4.53334 15.3334 4.8 15.6001 5.2Z"
            fill={props?.color ?? "black"}
          />
          <path
            opacity="0.8"
            d="M8 10.9333C7.73333 10.5333 7.53333 10.0667 7.4 9.53335H6.86667C5.13333 9.46668 3.46667 10.0667 2.2 11.1333L2 11.3333V16.6667H3.33333V11.8667C4.4 11.1333 5.6 10.7333 6.86667 10.8C7.26667 10.8 7.66667 10.8667 8 10.9333Z"
            fill={props?.color ?? "black"}
          />
          <path
            opacity="0.8"
            d="M6.86668 8.73333C7.00001 8.73333 7.13334 8.73333 7.26667 8.66666V8.26666C7.26667 7.93333 7.26668 7.59999 7.33334 7.33333C7.20001 7.39999 7.00001 7.39999 6.86668 7.39999C6.00001 7.39999 5.26668 6.66666 5.26668 5.79999C5.26668 4.93333 6.00001 4.19999 6.86668 4.19999C7.53334 4.19999 8.13334 4.59999 8.40001 5.19999C8.66668 4.86666 9.06668 4.53333 9.40001 4.26666C8.53334 2.86666 6.73334 2.39999 5.33334 3.26666C3.93334 4.13333 3.46668 5.93333 4.33334 7.33333C4.86668 8.19999 5.80001 8.73333 6.86668 8.73333Z"
            fill={props?.color ?? "black"}
          />
          <path
            opacity="0.8"
            d="M17.4001 15.1333L17.2667 14.9333C15.9334 13.4667 14.0667 12.6 12.0667 12.6667C10.0667 12.6 8.13341 13.4667 6.80008 14.9333L6.66675 15.1333V20.2C6.66675 20.8 7.13341 21.3333 7.80008 21.3333H16.3334C16.9334 21.3333 17.4667 20.8 17.4667 20.2V15.1333H17.4001ZM16.0667 20H8.00008V15.6C9.06675 14.5333 10.5334 14 12.0667 14C13.5334 13.9333 15.0001 14.5333 16.0667 15.6V20Z"
            fill={props?.color ?? "black"}
          />
        </g>
        <defs>
          <clipPath id="clip0_1039_10475">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default CustomerIcon;
